import { render } from "./IconNavigation.vue?vue&type=template&id=206f5403&scoped=true&ts=true"
import script from "./IconNavigation.vue?vue&type=script&lang=ts"
export * from "./IconNavigation.vue?vue&type=script&lang=ts"

import "./IconNavigation.vue?vue&type=style&index=0&id=206f5403&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206f5403"]])

export default __exports__